import { IConfigService } from '../config/ConfigService';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

export class MFAService implements IService {
    private MFAResource;

    constructor($resource: angular.resource.IResourceService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
      let roleResource = $resource(`${configService.getServerBaseUrlForResource()}/account/mfa`,
        {},
        {update: {method: "PUT"}});

      this.MFAResource = resourceWrapperService.WrapActions(roleResource);
    }

    public findByProjectId(projectId: string, callBack: Function) {
      //return this.ItemResource.query({projectId: projectId}, (roles) => callBack && callBack(roles));
    }

    public startVerification(callBack: Function) {

    }
}

frontendApp.factory("MFAService", ["$resource", "ConfigService", "ResourceWrapperService", function($resource, configService, resourceWrapperService) {
  return new MFAService($resource, configService, resourceWrapperService);
}]);
